import React, { useEffect, useState } from "react";
import Breadcrumb from "../../../../Components/Breadcrumb/Breadcrumb";
import axios from "axios";
import Cookies from "js-cookie";
import Modal from "react-bootstrap/Modal";
import EvnVar, { newEvn } from "../../../../EnvVar";
import Form from "react-bootstrap/Form";
import { useRole } from "../../../../RoleContext";

function Gallery() {
  const baseURL = EvnVar();
  const domain_url = newEvn();
  const token = Cookies.get("jwt");
  const [eventData, setEventData] = useState([]);
  const { role } = useRole();

  useEffect(() => {
    function getEventData() {
      let config = {
        method: "get",
        maxBodyLength: Infinity,
        url: `${baseURL}/user/events`,
        headers: {
          Authorization: token,
        },
        withCredentials: true,
      };

      axios
        .request(config)
        .then((response) => {
          let result = JSON.stringify(response.data);
          let data = JSON.parse(result);
          setEventData(data.events);
        })
        .catch((error) => {
          console.log("Error fetching data:", error);
        });
    }

    getEventData();
  }, []);

  const [showMedia, setShowMedia] = useState(false);
  const mediaClose = () => setShowMedia(false);
  const mediaShow = () => setShowMedia(true);

  const [mediaget, setMediaget] = useState([]);
  const [loaderShow, setLoaderShow] = useState(false);
  const getMediaAPI = (e) => {
    setLoaderShow(true);
    let id = e.target.id;
    // console.log("Event Id ==>", id);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${baseURL}/user/mediabyevent?eventId=${id}`,
      headers: {
        Authorization: token,
      },
      withCredentials: true,
    };

    axios
      .request(config)
      .then((response) => {
        let mediaData = JSON.stringify(response.data.media);
        let mediaJsonData = JSON.parse(mediaData);
        // console.log("Media", mediaJsonData);
        setMediaget(mediaJsonData);
        setLoaderShow(false);
      })
      .catch((error) => {
        console.log(error);
        setLoaderShow(false);
      });
  };

  function mediaFlush() {
    setMediaget([]);
  }

  const handleApproval = (id, checked) => {
    let approvalData = JSON.stringify({
      id: id,
      isapproved: checked,
    });

    // console.log("Approval Data", approvalData);

    let config = {
      method: "put",
      maxBodyLength: Infinity,
      url: `${baseURL}/user/updateMedia`,
      headers: {
        "content-type": "application/json",
        Authorization: token,
      },
      withCredentials: true,
      data: approvalData,
    };

    axios
      .request(config)
      .then((response) => {
        // console.log("Approval Response", JSON.stringify(response.data));
      })
      .catch((error) => {
        console.log(error);
      });

    setMediaget((prevMedia) => {
      return prevMedia.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            isapproved: checked ? true : false,
          };
        }
        return item;
      });
    });
  };

  return (
    <>
      <Breadcrumb data="Upload Event" />
      <div className="content-body">
        <form>
          <div className="table-data">
            <div className="d-flex align-items-center justify-content-between mb-3">
              <h5 className="mb-0">All Events</h5>
            </div>
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Event Name</th>
                    <th>Date</th>
                    <th>Media</th>
                  </tr>
                </thead>
                <tbody>
                  {eventData &&
                    eventData.map((value, index) => {
                      const isoDateString = value.date;
                      const date = new Date(isoDateString);

                      const options = {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                        hour: "numeric",
                        minute: "numeric",
                        second: "numeric",
                        hour12: true,
                      };

                      const formattedDateTime = date.toLocaleString(
                        undefined,
                        options
                      );
                      return (
                        <tr key={index}>
                          <td>{value.name}</td>
                          <td>{formattedDateTime}</td>
                          <td>
                            <button
                              type="button"
                              className="download-btn"
                              id={`${value.id}`}
                              onClick={(e) => {
                                mediaShow();
                                getMediaAPI(e);
                              }}
                            >
                              Media
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        </form>
      </div>
      <Modal show={showMedia} onHide={mediaClose} centered size="xl">
        <Modal.Header className="d-flex justify-content-between align-content-center">
          <Modal.Title>Upload Image</Modal.Title>
          <i
            className="fa-solid fa-xmark close-media"
            onClick={() => {
              mediaClose();
              mediaFlush();
            }}
          ></i>
        </Modal.Header>
        <Modal.Body className="upload-media">
          {loaderShow && loaderShow ? (
            <div
              className="text-center"
              style={{
                height: "6rem",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : mediaget && mediaget.length ? (
            <form>
              <div className="row">
                {mediaget.map((value, index) => (
                  <div className="col-lg-2 mb-3" key={index} id={index}>
                    <div
                      className="w-100"
                      style={{
                        backgroundColor: "#eee",
                        borderRadius: "5px",
                        padding: "5px",
                        height: "200px",
                        overflow: "hidden",
                      }}
                    >
                      <img
                        className="img-fluid object-fit-cover h-100 w-100"
                        src={`${domain_url}${value.url}`}
                        alt={value.event_id}
                        style={{ objectPosition: "center" }}
                      />
                    </div>
                    <Form.Check
                      className="approval-switch"
                      type="switch"
                      id={`approvel${value.id}`}
                      label="Approval"
                      disabled={role !== "admin"}
                      checked={value.isapproved}
                      onChange={(e) =>
                        handleApproval(value.id, e.target.checked)
                      }
                    />
                  </div>
                ))}
              </div>
            </form>
          ) : (
            <h2
              style={{
                color: "#34395e",
                textAlign: "center",
                textTransform: "capitalize",
              }}
            >
              No media found!
            </h2>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Gallery;
